import { API_BASE_URL } from 'src/globals';
import { getAuthenticationHeaders, getErrorMessage } from './utils';
import apiProvider from './provider';
import {
  SEARCH_TEAM,
  ADD_TEAM,
  ADD_MEMBERS,
  FETCH_ALL_TEAM,
  SEARCH_TEAM_MEMBERS,
  DELETE_USER_FROM_TEAM,
  FETCH_ALL_USERS_IN_TEAM,
  SEARCH_USER,
  FETCH_USER_TEAMS,
} from './routes';
import { ApiResponseWrapper, GET } from './apiHandler';
import { AxiosResponse } from 'axios';

export const searchTeam = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      `${API_BASE_URL}${SEARCH_TEAM}`,
      { params,
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const createTeam = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${ADD_TEAM}`,
      body,
      { headers: getAuthenticationHeaders() },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const searchTeamMembers = async (params)  => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(
      `${API_BASE_URL}${SEARCH_TEAM_MEMBERS}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess : true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const searchUser = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(
      `${API_BASE_URL}${SEARCH_USER}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess : true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
}
export const fetchAllTeams = async (params = {}) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      `${API_BASE_URL}${FETCH_ALL_TEAM}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchUserTeams =  () => {
  return GET(`${API_BASE_URL}${FETCH_USER_TEAMS}`, { disableAdmin: true })
}

export const addMembers = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${ADD_MEMBERS}`,
      body,
      { headers: getAuthenticationHeaders() },
      );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const editTeam = async (body) => {
  try {
    const response = await apiProvider.put(
      `${API_BASE_URL}${ADD_TEAM}`,
      body,
      { headers: getAuthenticationHeaders() },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const deleteUserFromTeam = async (params) => {
  try {
    const response = await apiProvider.delete(
      `${API_BASE_URL}${DELETE_USER_FROM_TEAM}`,
      {
        headers: getAuthenticationHeaders(),
        data: params,
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchAllUsersInTeam = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      `${API_BASE_URL}${FETCH_ALL_USERS_IN_TEAM}/${params}`,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
